var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        _vm._l(_vm.passengers, function (passenger, index) {
          return _c("div", { staticClass: "form-box" }, [
            _c("div", { staticClass: "form-content " }, [
              _c("form", { staticClass: "contact-form-action" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                    _c("div", { staticClass: "input-box" }, [
                      _c("label", { staticClass: "label-text" }, [
                        _vm._v("İsim Soyisim"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("span", { staticClass: "span-text" }, [
                          _vm._v(
                            _vm._s(passenger.name) +
                              " " +
                              _vm._s(passenger.lastName)
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                    _c("div", { staticClass: "input-box" }, [
                      _c("label", { staticClass: "label-text" }, [
                        _vm._v("Tc Kimlik No *"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("span", { staticClass: "span-text" }, [
                          _vm._v(_vm._s(passenger.tckNo)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                    _c("div", { staticClass: "input-box" }, [
                      _c("label", { staticClass: "label-text" }, [
                        _vm._v("Cinsiyet *"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("span", { staticClass: "span-text" }, [
                          _vm._v(_vm._s(passenger.gender)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                    _c("div", { staticClass: "input-box" }, [
                      _c("label", { staticClass: "label-text" }, [
                        _vm._v("Doğum Tarihi *"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("span", { staticClass: "span-text" }, [
                          _vm._v(
                            _vm._s(_vm._f("ddMMyyyy")(passenger.birthDate))
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                    _c("div", { staticClass: "input-box" }, [
                      _c("label", { staticClass: "label-text" }, [
                        _vm._v("Pasaport"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("span", { staticClass: "span-text" }, [
                          _vm._v(_vm._s(passenger.passportNumber)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                    _c("div", { staticClass: "input-box" }, [
                      _c("label", { staticClass: "label-text" }, [
                        _vm._v("Pasaport Son Geçerlilik"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("span", { staticClass: "span-text" }, [
                          _vm._v(
                            _vm._s(_vm._f("ddMMyyyy")(passenger.expireDate))
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.myCruiseRoomId[passenger.cruiseRoomId] !== undefined
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                        _c("div", { staticClass: "input-box" }, [
                          _c("label", { staticClass: "label-text" }, [
                            _vm._v("Resim *"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("big-image-component", {
                                attrs: {
                                  url: _vm.myCruiseRoomId[
                                    passenger.cruiseRoomId
                                  ].imageUrl,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                        _c("div", { staticClass: "input-box" }, [
                          _c("label", { staticClass: "label-text" }, [
                            _vm._v("Oda Adı *"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("span", { staticClass: "span-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.myCruiseRoomId[passenger.cruiseRoomId]
                                    .name
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                        _c("div", { staticClass: "input-box" }, [
                          _c("label", { staticClass: "label-text" }, [
                            _vm._v("Kabin Tipi *"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("span", { staticClass: "span-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.myCruiseRoomId[passenger.cruiseRoomId]
                                    .cabinType.name
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                        _c("div", { staticClass: "input-box" }, [
                          _c("label", { staticClass: "label-text" }, [
                            _vm._v("Room Number *"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("span", { staticClass: "span-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getCruiseRoomNumber(
                                    passenger.cruiseRoomId
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-2 responsive-column" }, [
                        _c("div", { staticClass: "input-box" }, [
                          _c("label", { staticClass: "label-text" }, [
                            _vm._v("Ülke"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("span", { staticClass: "span-text" }, [
                              _vm._v(_vm._s(passenger.country)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }